export const setConfig = (config) => {
  return {
    type: 'SET_CONFIG',
    config,
  };
};
